import React, { useState } from 'react';
import { Box, Typography, Button, Container, useTheme } from '@mui/material';
import { Link } from "react-router-dom";

const sections = [
    {
        bgColor: 'rgba(255, 255, 255, 0.36)',
        clip: 'polygon(0 0, 100% 5%, 100% 100%, 0 95%)',
        description: 'Are you trying to balance potential study delays caused by the lack of resource management tools that are available to you? This is normal, resource management is among the most critical and most challenging aspects of clinical trial management. Failing to book the right resources, to the right tasks, at the right time, and at the right cost can lead to budget and schedule overruns. The inaccuracy also creates frustrated team members, stakeholders and customers. Whether you are currently using Excel or an expensive tool that requires a specific team to manage, it is time for a change. Fortunately, the Insights RM tool is a proven industry leader in the resource management space that ensures pharmaceutical and CRO companies world-wide achieve clinical trial success within budget.',
    },
    {
        image: '/insightsgrid.png',
        bgColor: 'rgba(59, 200, 239, 0.2)',
        clip: 'polygon(0 5%, 100% 0, 100% 95%, 0 100%)',
        title: 'Insights RM Feature & Benefits',
        paragraphs: [
            'Manage Resources for Clinical Trials– know how many resources you need and when. Have confidence that your studies are properly staffed, that there is little bench time and that resources are managed within budget',

            'Plan and Align Resources – increase visibility and control over resourcing. See who’s available to work by skill set and when and understand how much work they can take on. Forecast staffing needs and shift resources to meet goals',
            'Scenario Planning – test hypothetical resource scenarios with the capability to visualize impacts on resources, capacity and projects. Build limitless models and create copies to model future scenarios with your current knowledge – all without altering live data',
            'Reports and Visualizations– utilize dynamic reporting and built-in visualizations to answer questions and create presentations around actuals, headcount, utilization, and availability.',
            'Quick implementation – Insights RM resource management software can be implemented in weeks – not months or years, like other enterprise resource management tools. ',
        ],
        //showButton: true,
        showFAQButton: true,
    },
    {
        bgColor: 'rgba(255, 255, 255, 0.36)',
        clip: 'polygon(0 0, 100% 5%, 100% 100%, 0 95%)',
        title: 'READY TO SEE MORE?',
        description: 'We’ll walk you through all the features and functionality that will help you use Insights RM to its fullest potential.',
        showButton: true,
    },
];

const IntrinsicInsights = () => {
    const [showVideo, setShowVideo] = useState(false);
    const theme = useTheme();


    return (
        <>
            <Box sx={{ py: 2, px: 3, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Typography

                    sx={{
                        fontWeight: 'bold',
                        color: theme.palette.mode === "dark" ? "white" : "black",
                        fontSize: '1.5rem',
                        mb: 2,
                    }}
                >
                    INSIGHTS RM
                </Typography>
                <Typography
                    variant="h4"
                    sx={{
                        mb: 2,
                        fontSize: '1.2rem',
                        textAlign: 'center',
                        maxWidth: '800px',
                    }}
                >
                    The resource management tool to ensure you achieve clinical trial success within budget
                </Typography>


                <Box
                    sx={{
                        flex: 1,
                        display: 'flex',
                        justifyContent: { xs: 'center', md: 'flex-end' },
                        maxWidth: '100%',
                    }}
                >
                    {!showVideo ? (
                        <img
                            src="/RM-video-Image.png" // thumbnail image
                            alt="Click to play"
                            onClick={() => setShowVideo(true)}
                            style={{
                                cursor: 'pointer',
                                borderRadius: '12px',
                                maxWidth: '500px',
                                boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                                width: '100%',
                                height: '300px',
                            }}
                        />
                    ) : (
                        <iframe
                            width="500"
                            height="300"
                            style={{
                                borderRadius: '12px',
                                maxWidth: '600px',
                                boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                            }}
                            src="https://www.youtube.com/embed/c4X54yyNYWM?autoplay=1"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    )}

                </Box>
            </Box>

            {sections.map((section, index) => (
                <Box
                    key={index}
                    sx={{
                        backgroundColor: section.bgColor,
                        clipPath: {
                            xs: 'none', // Disable angled background on mobile
                            sm:
                                index % 2 === 0
                                    ? 'polygon(0 0, 100% 20%, 100% 100%, 0 80%)'
                                    : 'polygon(0 20%, 100% 0, 100% 80%, 0 100%)',
                        },
                        mt: index === 0 ? 0 : { xs: 0, md: '-80px' },
                        py: { xs: 6, sm: 8, md: 12 },
                        px: { xs: 2, sm: 4, md: 20 },
                    }}
                >
                    <Container
                        maxWidth="lg"
                        sx={{
                            p: { xs: 0, sm: 2 },
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: {
                                    xs: 'column',
                                    md: index % 2 === 0 ? 'row' : 'row-reverse',
                                },
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: { xs: 2, md: 6 },
                                width: '100%',
                            }}
                        >
                            {/* TEXT BLOCK */}
                            <Box
                                sx={{
                                    flex: 1,
                                    width: '100%',
                                    textAlign: { xs: 'left', },
                                    px: { xs: 1, sm: 2, md: 6 },

                                }}
                            >
                                {section.title && (
                                    <Typography
                                        variant="h5"

                                        sx={{
                                            mt:5,
                                            fontWeight: 'bold',
                                            color: theme.palette.mode === 'dark' ? 'white' : 'black',
                                            mb: 3,
                                            fontSize: { xs: '1.1rem', sm: '1.4rem', md: '1.7rem' },
                                            textAlign: { xs: 'center', },
                                        }}
                                    >
                                        {section.title}
                                    </Typography>
                                )}

                                {section.paragraphs ? (
                                    <Box component="ul" sx={{ pl: { xs: 2, md: 3 }, mb: 3 }}>
                                        {section.paragraphs.map((para, idx) => {
                                            const hasDash = para.includes('–');
                                            const [boldPart, ...restParts] = para.split('–');
                                            const rest = restParts.join('–');
                                            return (
                                                <Typography
                                                    key={idx}
                                                    component="li"
                                                    variant="body1"
                                                    sx={{
                                                        mb: 2,
                                                        fontSize: { xs: '0.95rem', sm: '1rem', md: '1.05rem' },
                                                        fontFamily: 'Montserrat, sans-serif',
                                                        color: theme.palette.mode === 'dark' ? 'white' : 'black',
                                                        lineHeight: { xs: 1.6, sm: 1.7 },
                                                        wordBreak: 'break-word',
                                                    }}
                                                >
                                                    {hasDash ? (
                                                        <>
                                                            <strong>{boldPart.trim()}</strong>
                                                            {rest ? ' – ' + rest.trim() : ''}
                                                        </>
                                                    ) : (
                                                        para
                                                    )}
                                                </Typography>
                                            );
                                        })}
                                    </Box>
                                ) : (
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            mb: section.showButton ? 3 : 0,
                                            fontSize: { xs: '0.95rem', sm: '1rem', md: '1.1rem' },
                                            fontFamily: 'Montserrat, sans-serif',
                                            color: theme.palette.mode === 'dark' ? 'white' : 'black',
                                            lineHeight: { xs: 1.7, sm: 1.8 },
                                        }}
                                    >
                                        {section.description}
                                    </Typography>
                                )}

                                {/* BUTTONS */}
                                {/* BUTTONS */}
                                {(section.showButton || section.showFAQButton) && (
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'center',  // ✅ centers horizontally
                                            alignItems: 'center',
                                            gap: 2,                    // spacing between buttons
                                            flexWrap: 'wrap',          // ✅ stack on small screens
                                            mt: 3,
                                            textAlign: 'center',
                                        }}
                                    >
                                        {section.showButton && (
                                            <Button
                                                variant="contained"
                                                component={Link}
                                                to="/request-demo"
                                                sx={{
                                                    backgroundColor: '#0cc0df',
                                                    color: '#FFFFFF',
                                                    px: { xs: 3, sm: 5 },
                                                    py: { xs: 1, sm: 1.5 },
                                                    fontSize: { xs: '0.9rem', sm: '1rem', md: '1.2rem' },
                                                    borderRadius: '50px',
                                                    textTransform: 'none',
                                                    fontWeight: 500,
                                                    boxShadow: '0px 4px 12px rgba(0, 174, 239, 0.4)',
                                                    '&:hover': {
                                                        backgroundColor: '#0cc0df',
                                                        transform: 'scale(1.05)',
                                                    },
                                                }}
                                            >
                                                Request a Demo
                                            </Button>
                                        )}

                                        {section.showFAQButton && (
                                            <Button
                                                variant="contained"
                                                component={Link}
                                                to="/faq"
                                                sx={{
                                                    backgroundColor: '#0cc0df',
                                                    color: '#FFFFFF',
                                                    px: { xs: 3, sm: 5 },
                                                    py: { xs: 1, sm: 1.5 },
                                                    fontSize: { xs: '0.9rem', sm: '1rem', md: '1.2rem' },
                                                    borderRadius: '50px',
                                                    textTransform: 'none',
                                                    fontWeight: 500,
                                                    boxShadow: '0px 4px 12px rgba(0, 174, 239, 0.4)',
                                                    '&:hover': {
                                                        backgroundColor: '#0cc0df',
                                                        transform: 'scale(1.05)',
                                                    },
                                                    mb:5,
                                                }}
                                            >
                                                Read our Insights RM FAQ
                                            </Button>
                                        )}
                                    </Box>
                                )}

                            </Box>
                        </Box>
                    </Container>
                </Box>

            ))}
        </>
    );
};

export default IntrinsicInsights;
